import FontBody2 from '../../../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../../../components/fonts/font-props';

import CustomCollapsible from '../../ui/custom-collapsible/custom-collapsible';

import FailedCheckItem from './failed-check-item';

interface FailedChecksSectionProps {
    failedChecks: Array<{
        policyName: string;
        level: string;
        reason: string;
    }>;
    isEligible: boolean;
}

const FailedChecksSection: React.FC<FailedChecksSectionProps> = ({ failedChecks, isEligible }) => {
    if (failedChecks.length === 0) {
        return null;
    }

    return (
        <CustomCollapsible
            title={
                <FontBody2 color={FONT_COLOR.SEMANTIC_DANGER} variant={[FONT_VARIANT.BOLD]}>
                    ⚠️ Failed Eligibility Checks ({failedChecks.length})
                </FontBody2>
            }
            isExpanded={!isEligible} // Only expand by default for ineligible items
            level="secondary"
        >
            <div className="failed-checks-section">
                {failedChecks.map((failedCheck, failedIndex) => (
                    <FailedCheckItem 
                        key={failedIndex} 
                        failedCheck={failedCheck} 
                    />
                ))}
            </div>
        </CustomCollapsible>
    );
};

export default FailedChecksSection;
